<template>
  <Modal v-model="showModal" draggable :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">合伙人审核</span>
    </p>
    <div style="position: relative;" :style="'height:' + height + 'px'">
      <Spin v-if="loadingStatus" fix />
      <Form ref="applyForm" :model="formFields" :label-width="110" :rules="ruleValidate">
        <FormItem label="分配角色:" prop="role">
          <Select
            v-model="formFields.role"
            :label-in-value="true"
            size="small"
            :loading="loadingStatus"
            @on-change="handleRoleChange"
          >
            <Option v-for="(option, index) in roleOptions" :key="index" :value="option.id" :label="option.name" />
          </Select>
        </FormItem>
        <FormItem label="申请类型:">
          <span style="font-size: 9pt;">{{ data ? data.typeName : '' }}</span>
        </FormItem>
        <FormItem label="会员姓名:">
          <span style="font-size: 9pt;">{{ data ? data.name : '' }}</span>
        </FormItem>
        <FormItem label="会员电话:">
          <span style="font-size: 9pt;">{{ data ? data.mobile : '' }}</span>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="approve"
      >
        更改状态
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'PartnerApply',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 250
    },
    action: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default() { return {} }
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      roleOptions: [],
      loadingStatus: false,
      selectLoading: false,
      modal: true,
      submit: false,
      formFields: {
        role: ''
      }
    }
  },
  computed: {
    ruleValidate() {
      return {
        role: [
          { required: true, message: '请选择分配角色..' }
        ]
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.$refs.applyForm.resetFields()
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.$config.apiContextPath + '/role?visible=1',
          method: 'get'
        }).then(res => {
          this.roleOptions = res.data.content
          this.loadingStatus = false
        }).catch(error => {
          console.log(error)
          this.roleOptions = []
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    handleRoleChange: function(selections) {
    },
    approve() {
      const _this = this
      this.$refs.applyForm.validate((valid) => {
        if (valid) {
          this.submit = true
          request({
            url: _this.action + '/' + _this.id + '/approval',
            method: 'POST',
            params: { status: 1, role: _this.formFields.role }
          }).then(res => {
            this.$Notice.success({ title: '用户审核成功' })
            this.closeModal(true)
          }).catch(() => {
            this.$Notice.error({ title: '用户审核失败' })
            this.closeModal(true)
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.roleOptions = []
      this.submit = false
      this.loadingStatus = false
      this.$emit('on-close', changed)
    }
  }
}
</script>
